import { useLocation, useNavigate } from 'react-router-dom';
import { useScrollToHash } from './useScrollToHash';

export function useNavigation() {
  const location = useLocation();
  const navigate = useNavigate();
  const { scrollToElement } = useScrollToHash();

  const navigateToSection = (sectionId: string) => {
    if (location.pathname !== '/') {
      navigate(`/#${sectionId}`);
    } else {
      // Update URL without triggering navigation
      window.history.replaceState(null, '', `#${sectionId}`);
      scrollToElement(sectionId);
    }
  };

  return { navigateToSection };
}